import React from 'react';
import Header from './Header';
import Events from './Events';
import Footer from './Footer';

const EventsPage = () => {
  return (
    <div className="events-page">
      <Header />
      <Events />
      <Footer />
    </div>
  );
};

export default EventsPage;